<template>
  <div>
    <!-- Header -->
    <div class="header bg-white py-3 py-lg-6 pt-lg-2">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <img src="img/logo.png" />
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-default" points="2560 0 2560 100 0 100" />
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5 login">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-3">
              <div class="text-center text-muted mb-4">SGE BANK - AMEnergia</div>
              <div class="alert alert-danger text-center" role="alert" v-show="alerta">
                <strong>Ops!</strong> Usuário ou senha inválida!
              </div>
              <form role="form">
                <base-input
                  alternative
                  class="mb-3"
                  prepend-icon="ni ni-email-83"
                  placeholder="Email"
                  v-model="email"
                ></base-input>

                <base-input
                  alternative
                  class="mb-3"
                  prepend-icon="ni ni-lock-circle-open"
                  type="password"
                  placeholder="Senha"
                  v-model="password"
                ></base-input>

                <div class="row mt-3">
                  <div class="col-6">
                    <router-link to="/" class="text-light">
                      <small></small>
                    </router-link>
                  </div>
                  <div class="col-6 text-right">
                    <router-link to="/" class="text-normal">
                      <small>Perdeu a senha?</small>
                    </router-link>
                  </div>
                </div>
                <div class="text-center">
                  <base-button type="success" class="my-4" @click="login()">Entrar</base-button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
@media only screen and (max-width: 600px) {
  .login {
    margin-top: -4rem !important;
  }
}
</style>
<script>
export default {
  data() {
    return {
      email: "",
      password: "",
      rememberMe: false,
      alerta: false,
    };
  },
  methods: {
    login() {
        this.alerta = false;
      if (this.email != "luciana@amee.com.br" && this.password != 123) {
        this.alerta = true;
        return false;
      }
      localStorage.setItem("nome", "Luciana Landulpho");
      this.$router.push("/dashboard");
    },
  },
};
</script>
